export const numberFormat = (value: unknown) => {
  return value || value === 0 || value === "0" ? new Intl.NumberFormat().format(Number(value)) : "";
};
